/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForAiPlatform extends models.ServiceAccountNativeDetailsBaseForResource {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForAiPlatform");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForAiPlatform.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForAiPlatform>): ServiceAccountNativeDetailsBaseForAiPlatform {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForAiPlatform(), model);
        ServiceAccountNativeDetailsBaseForAiPlatform.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForAiPlatform>): ServiceAccountNativeDetailsBaseForAiPlatform {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForAiPlatform.newInstance(<ServiceAccountNativeDetailsBaseForAiPlatform> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForAiPlatform) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForAiPlatform.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForAiPlatform): boolean {
        if (models.ServiceAccountNativeDetailsBaseForResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForAiPlatform.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
